import { apiRequest } from './http';
import type { LookupResult } from './types';

export type LookupKind = 'people' | 'companies' | 'projects' | 'contacts';

export interface LookupResponse {
  items: LookupResult[];
  /** Every country the records span, so the picker can offer them as a filter. */
  countries: string[];
}

/**
 * Search is server-side: the client data API has no search endpoint, so the
 * whole list is cached on the server and filtered there rather than shipping
 * thousands of records to the browser.
 *
 * `companyId` is Project/Contact-only (Linked Company): the server hard-restricts
 * the result set to that company's records. Ignored by the companies/people routes.
 */
export async function lookup(kind: LookupKind, query: string, country = '', companyId = ''): Promise<LookupResponse> {
  const params = new URLSearchParams({ q: query });
  if (country) params.set('country', country);
  if (companyId) params.set('companyId', companyId);

  const response = await apiRequest<Partial<LookupResponse>>(`/api/lookup/${kind}?${params}`);
  return { items: response.items ?? [], countries: response.countries ?? [] };
}
